var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* ユーザ管理画面 */
import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowzerBack } from '../../BrowzerBack';
import { user_search_params_init } from '../../Const';
import { scrollPageTop } from '../../Scroll';
import { parse } from 'querystring';
import { jumpUrl, getLanguage } from '../../Common';
import UserSearchForm from '../../organisms/UserSearchForm';
import UserList from '../../organisms/UserList';
import LoadingModal from '../../organisms/LoadingModal';
import { useTranslation } from 'react-i18next';
import '../../i18n';
var User = function () {
    var _a = useState([]), users = _a[0], setUsers = _a[1];
    var _b = useState(), options = _b[0], setOptions = _b[1];
    var _c = useState(user_search_params_init), search_params = _c[0], setSearchParams = _c[1]; // 検索パラメータ
    var _d = useState(false), is_loading = _d[0], setIsLoading = _d[1]; // ローディングフラグ
    var _e = useState(false), is_connecting = _e[0], setIsConnecting = _e[1]; // Ajaxリクエスト中フラグ
    var _f = useTranslation(), t = _f.t, i18n = _f.i18n;
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        // 言語変更
        i18n.changeLanguage(getLanguage());
        var getUserList = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        return [4 /*yield*/, axios.get('/staff/maintenance/user/init')];
                    case 1:
                        response = _a.sent();
                        setUsers(response.data.user_list);
                        setOptions(response.data.options);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //画面トップに遷移
                        scrollPageTop();
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 検索パラメータの初期値を設定
        var new_params = Object.assign({}, search_params);
        if (location.search.length > 0) {
            // getパラメータをパースする
            var get_queries = parse(location.search.slice(1));
            // 検索パラメータの初期化状態にマージする
            Object.assign(new_params, get_queries);
            // パラメータを更新する
            setSearchParams(new_params);
        }
        // Ajaxリクエスト
        getUserList();
    }, []);
    // 検索処理
    var handleClickSearch = useCallback(function () {
        // クリックイベント
        var searchProjects = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, exception_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        setIsConnecting(true);
                        return [4 /*yield*/, axios.post('/staff/maintenance/user/search', search_params)];
                    case 1:
                        response = _a.sent();
                        setUsers(response.data.user_list);
                        return [3 /*break*/, 4];
                    case 2:
                        exception_1 = _a.sent();
                        console.error(exception_1);
                        jumpUrl(exception_1.response.data.url);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsConnecting(false);
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        searchProjects();
    }, [search_params]);
    // 追加処理
    var handleClickAdd = useCallback(function () {
        // クリックイベント
        location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/maintenance/user/detail/add";
    }, []);
    // 検索パラメータ変更
    var handleChangeSearchParams = useCallback(function (target, param) {
        var params = Object.assign({}, search_params);
        var set_targets = [];
        // targetが単一stringであるかをチェックする
        if (typeof target === 'string') {
            set_targets.push(target);
        }
        else {
            target.map(function (param) { return set_targets.push(param); });
        }
        // targetの個数分だけ繰り返しパラメータをセットする
        set_targets.map(function (target_param) {
            // string型
            var set_param = typeof param === 'string' ? param : '';
            var key = target_param; // targetの型を明示的に指定
            params[key] = set_param;
        });
        setSearchParams(params);
    }, [search_params]);
    return (React.createElement("div", null,
        React.createElement("div", { className: "container" },
            React.createElement(UserSearchForm, { options: options, search_params: search_params, handleClickSearch: handleClickSearch, handleClickAdd: handleClickAdd, handleChangeSearchParams: handleChangeSearchParams, t: t }),
            React.createElement(UserList, { users: users, options: options, t: t })),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('maintenance-user')) {
    render(React.createElement(User, null), document.getElementById('maintenance-user'));
}
